import React, { useEffect, useState } from 'react';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';
import { MAGENTA } from './landingTokens';

export const WORDS = ['PARTY.', 'PEOPLE.', 'PERSON.'];

/**
 * `FIND YOUR {word}` — the last word flips up through PARTY. / PEOPLE. / PERSON. every 2.4s
 * (0.5s, cubic-bezier(.2,.7,.2,1)). The box is one em tall and as wide as the current word,
 * so the headline never jumps. Under reduced motion it holds on PARTY.
 */
export default function Roller() {
  const reduced = usePrefersReducedMotion();
  const [cur, setCur] = useState(0);
  const [prev, setPrev] = useState(null);

  useEffect(() => {
    if (reduced) return undefined;
    const id = setInterval(() => setCur((c) => { setPrev(c); return (c + 1) % WORDS.length; }), 2400);
    return () => clearInterval(id);
  }, [reduced]);

  return (
    <span data-testid="roller" style={{ position: 'relative', display: 'inline-block', verticalAlign: 'top', overflow: 'hidden', height: '1em', lineHeight: 1, width: `${WORDS[cur].length * 0.64}em`, transition: 'width .5s cubic-bezier(.2,.7,.2,1)', color: MAGENTA, textAlign: 'left' }}>
      {prev != null && prev !== cur && (
        <span key={`out-${prev}-${cur}`} className="pl-flip-out" style={{ display: 'block', position: 'absolute', left: 0, top: 0 }}>{WORDS[prev]}</span>
      )}
      <span key={`in-${cur}`} className={prev == null ? undefined : 'pl-flip-in'} style={{ display: 'block' }}>{WORDS[cur]}</span>
    </span>
  );
}
